/* Skeleton.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP5zaO%7Bpadding-inline-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtko5zaO%7Bpadding-block-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E5zaO%7Bpadding-inline-start%3Avar(--ds-space-200%2C1pc)%7D");
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import Inline from '@atlaskit/primitives/inline';
import Stack from '@atlaskit/primitives/stack';
import { LoadingSkeleton } from '@townsquare/loading-skeleton';
import { SquareLoadingSkeleton } from '@townsquare/loading-skeleton/component';
const compiledStyles = {
  root: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _46hvQm5zaO _03SyCP5zaO _0xmtko5zaO _0LQT5E5zaO"
};
export function AgentSkeleton(): React.JSX.Element {
  return <Box xcss={compiledStyles.root} testId="agent-browse-card-skeleton">
			<Stack grow="fill" space="space.200" spread="space-between">
				<Inline space="space.100" alignInline="start" alignBlock="center">
					<SquareLoadingSkeleton sideLengthPx={40} />
					<Stack space="space.100">
						<LoadingSkeleton width="150px" height="20px" />
						<LoadingSkeleton width="190px" height="20px" />
					</Stack>
				</Inline>
				<LoadingSkeleton height="40px" />
			</Stack>
		</Box>;
}